<template>
    <v-container class="pa-0">
        <v-row no-gutters>
            <v-col :cols="12">
                <FormHeader title="EVENT DETAILS" />
            </v-col>
        </v-row>
        <v-container class="white pt-8">
            <v-row no-gutters align="baseline">
                <v-col cols="2">
                    <v-subheader>URL:</v-subheader>
                </v-col>
                <v-col cols="10" class="pl-4" lg="4" >
                    <v-sheet>
                        <v-autocomplete
                                v-model="urlData"
                                :items="getWebsitesList"
                                placeholder="Select URL"
                                item-value="id"
                                item-text="url"
                                required
                                :rules="[v => !!(v && Object.keys(v).length !== 0) || 'This field is required']"
                                return-object
                                dense
                                outlined
                                name="urlName"
                                @input="handleSetUrl"
                        ></v-autocomplete>
                    </v-sheet>
                </v-col>
                <v-col cols="2" lg="1">
                    <v-subheader>PATH:</v-subheader>
                </v-col>
                <v-col cols="10" class="pl-4" lg="4">
                    <v-sheet>
                        <v-text-field
                                v-model="pathData"
                                name="pathName"
                                id="pathName"
                                type="text"
                                single-line
                                dense
                                outlined
                                placeholder="/example"
                                @change="handleSetPath(pathData)"
                        /></v-sheet>
                </v-col>
            </v-row>
            <v-row no-gutters align="baseline">
                <v-col cols="2">
                    <v-subheader>PAGE:</v-subheader>
                </v-col>
                <v-col cols="10" class="pl-4" lg="4">
                    <v-sheet>
                        <v-autocomplete
                                v-model="pageData"
                                :items="getPageIdList"
                                placeholder="Select ID"
                                required
                                item-value="id"
                                item-text="name"
                                name="pageName"
                                dense
                                return-object
                                outlined
                                @input="handleSetPage"
                                :rules="[v => !!(v && Object.keys(v).length !== 0) || 'This field is required']"
                        ></v-autocomplete>
                    </v-sheet>
                </v-col>
            </v-row>
            <v-row no-gutters align="baseline">
                <v-col cols="2">
                    <v-subheader>CONSENT TYPE:</v-subheader>
                </v-col>
                <v-col cols="10" class="pl-4" lg="4">
                    <v-sheet>
                        <v-autocomplete
                                placeholder="Select consent type"
                                v-model="consentTypeData"
                                :items="getConsentTypeList"
                                item-value="id"
                                item-text="description"
                                name="consentType"
                                dense
                                outlined
                                return-object
                                @input="handleSetConsentType"
                                :rules="[v => !!(v && Object.keys(v).length !== 0) || 'This field is required']"
                        ></v-autocomplete>
                    </v-sheet>
                </v-col>
            </v-row>
            <v-row no-gutters align="baseline" >
                <v-col cols="2">
                    <v-subheader>Default delay</v-subheader>
                </v-col>
                <v-col cols="2" class="pl-4 mr-2 pr-2 input-72">
                    <v-sheet>
                        <v-text-field
                                v-model="defaultDelayData"
                                required
                                name="default_delay"
                                type="number"
                                min=0
                                single-line
                                outlined
                                dense
                                placeholder="0"
                                @change="handleSetDefaultDelay(defaultDelayData)"
                                :rules="[v => !!(v && v > 0) || 'Value must be more than 0']"
                        ></v-text-field
                        ></v-sheet>
                </v-col>
                <v-col cols="1">
                    <v-subheader>(seconds)</v-subheader>
                </v-col>
            </v-row>
            <v-row no-gutters align="baseline" >
                <v-col cols="2">
                    <v-subheader>Scan frequency</v-subheader>
                </v-col>
                <v-col cols="2" class="pl-4 mr-2 pr-2 input-72">
                    <v-sheet>
                        <v-text-field
                                v-model="scanFrequencyData"
                                required
                                name="scanFrequency"
                                type="number"
                                min=0
                                single-line
                                outlined
                                dense
                                placeholder="0"
                                @change="handleSetScanFrequency(scanFrequencyData)"
                                :rules="[v => !!(v && v > 0) || 'Value must be more than 0']"
                        ></v-text-field
                        ></v-sheet>
                </v-col>
                <v-col cols="1">
                    <v-subheader>(hours)</v-subheader>
                </v-col>
            </v-row>
        </v-container>
    </v-container>
</template>

<script>
    import FormHeader from "../FormHeader";
    import { createNamespacedHelpers } from "vuex";
    const formHelper = createNamespacedHelpers("form");

    export default {
        name: "DetailForm",
        components: { FormHeader },
        data() {
            return {
                urlData: {},
                pathData: '',
                pageData: {},
                consentTypeData:{},
                scanFrequencyData: 6,
                defaultDelayData: 30,
            };
        },
        props: {
            errorMessages: {
                type: Object,
                required: true
            },
            url: {
                type: Object,
            },
            path: {
                type: String
            },
            consentType: {
                type: Object,
            },
            page: {
                type: Object,
            },
            defaultDelay: {
                type: Number
            },
            scanFrequency: {
                type: Number
            },
        },
        computed: {
            ...formHelper.mapGetters(["getWebsitesList","getPageIdList","getConsentTypeList"]),
        },
        methods: {
            handleSetUrl(url){
                this.$emit('set-url', url);
            },
            handleSetPath(e){
                this.$emit('set-path', e);
            },
            handleSetConsentType(type){
                this.$emit('set-consent-type', { name: type.name, id: type.id });
            },
            handleSetPage(page){
                this.$emit('set-page', { name: page.name, id: page.id });
            },
            handleSetDefaultDelay(e){
                this.$emit('set-default-delay', +e);
            },
            handleSetScanFrequency(e){
                this.$emit('set-scan-frequency', +e);
            },
        },
        created() {
            if(this.$route.params.scanId){
                this.urlData = this.url;
                this.pathData = this.path;
                this.pageData = this.page;
                this.consentTypeData = this.consentType;
                this.scanFrequencyData = this.scanFrequency;
                this.defaultDelayData = this.defaultDelay;
            }
        }
    };
</script>
